export const parsePrice = (value) => {
    const num = Number(String(value ?? "").replace(/\s/g, "").replace(",", "."));
    return Number.isFinite(num) ? num : null;
};

export const formatPrice = (value) => {
    if (value === null || value === undefined || Number.isNaN(value)) return "-";
    return new Intl.NumberFormat("ru-RU").format(value);
};
